import { ColDef } from 'ag-grid-community';
import { TokenCellRenderer } from './cellRenderers/TokenCellRenderer';
import { PriceCellRenderer } from './cellRenderers/PriceCellRenderer';
import { ChangeCellRenderer } from './cellRenderers/ChangeCellRenderer';
import { TokenAmountCellRenderer } from './cellRenderers/TokenAmountCellRenderer';
import { ValueCellRenderer } from './cellRenderers/ValueCellRenderer';
import { ContractCellRenderer } from './cellRenderers/ContractCellRenderer';
import { TransactionCountCellRenderer } from './cellRenderers/TransactionCountCellRenderer';
import { TokenFlowCellRenderer } from './cellRenderers/TokenFlowCellRenderer';

const tokenColDef: ColDef = {
  field: 'symbol',
  headerName: 'Token',
  width: 200,
  headerClass: 'font-bold',
  cellRenderer: TokenCellRenderer,
  filter: 'agTextColumnFilter',
  filterParams: {
    filterOptions: ['contains', 'startsWith', 'endsWith'],
    defaultOption: 'contains',
  },
  valueGetter: (params) => {
    const token = params.data;
    if (!token) return '';
    return `${token.name} ${token.symbol}`.toLowerCase();
  },
};

const contractColDef: ColDef = {
  field: 'token_address',
  headerName: 'Contract',
  width: 150,
  headerClass: 'font-bold',
  cellRenderer: ContractCellRenderer,
  filter: 'agTextColumnFilter',
  filterParams: {
    filterOptions: ['contains', 'startsWith', 'endsWith'],
    defaultOption: 'contains',
  },
};

const priceColDef: ColDef = {
  field: 'price_usd',
  headerName: 'Price',
  width: 130,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: PriceCellRenderer,
  filter: 'agNumberColumnFilter',
  filterParams: {
    filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
    defaultOption: 'greaterThan',
    allowedCharPattern: '\\d\\-\\.',
  },
};

const changeColDef: ColDef = {
  field: 'current_day_change_percent',
  headerName: 'Change(24H)',
  width: 130,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: ChangeCellRenderer,
  filter: 'agNumberColumnFilter',
  filterParams: {
    filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
    defaultOption: 'greaterThan',
    allowedCharPattern: '\\d\\-\\.',
  },
};

const amountColDef: ColDef = {
  field: 'actual_balance',
  headerName: 'Amount',
  width: 180,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: TokenAmountCellRenderer,
  filter: 'agNumberColumnFilter',
  filterParams: {
    filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
    defaultOption: 'greaterThan',
    allowedCharPattern: '\\d\\-\\.',
  },
};

const valueColDef: ColDef = {
  field: 'total_value_usd',
  headerName: 'Value',
  width: 150,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: ValueCellRenderer,
  filter: 'agNumberColumnFilter',
  filterParams: {
    filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
    defaultOption: 'greaterThan',
    allowedCharPattern: '\\d\\-\\.',
  },
};

const transactionCountColDef: ColDef = {
  field: 'total_number_of_transactions',
  headerName: 'Total Transactions',
  width: 160,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: TransactionCountCellRenderer,
  filter: 'agNumberColumnFilter',
  filterParams: {
    filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
    defaultOption: 'greaterThan',
    allowedCharPattern: '\\d',
  },
};

const totalIncomingColDef: ColDef = {
  field: 'total_incoming',
  headerName: 'Total Incoming',
  width: 180,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: TokenFlowCellRenderer,
  cellRendererParams: {
    flowType: 'incoming',
  },
  filter: 'agNumberColumnFilter',
  filterParams: {
    filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
    defaultOption: 'greaterThan',
    allowedCharPattern: '\\d\\-\\.',
  },
};

const totalOutgoingColDef: ColDef = {
  field: 'total_outgoing',
  headerName: 'Total Outgoing',
  width: 180,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: TokenFlowCellRenderer,
  cellRendererParams: {
    flowType: 'outgoing',
  },
  filter: 'agNumberColumnFilter',
  filterParams: {
    filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
    defaultOption: 'greaterThan',
    allowedCharPattern: '\\d\\-\\.',
  },
};

export const tokenHoldingsColDefs: ColDef[] = [
  tokenColDef,
  contractColDef,
  priceColDef,
  changeColDef,
  amountColDef,
  valueColDef,
  transactionCountColDef,
  totalIncomingColDef,
  totalOutgoingColDef,
];
